import { render, staticRenderFns } from "./PeopleDetail.vue?vue&type=template&id=74e8b413&scoped=true&"
import script from "./PeopleDetail.vue?vue&type=script&lang=ts&"
export * from "./PeopleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PeopleDetail.vue?vue&type=style&index=0&id=74e8b413&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e8b413",
  null
  
)

export default component.exports